// extracted by mini-css-extract-plugin
export default {"title":"BlogCard_title__ZCFWf","description":"BlogCard_description__I5Vqn"};